'use strict';
var React = require('react');
var assetsHelper = require('../helper/assetsHelper');
var i18nHelper = require('../helper/i18n');

var ErrorMessage = React.createClass({
  propTypes: {
    error: React.PropTypes.string,
    onClearError: React.PropTypes.func
  },
  render: function () {
    if (this.props.error) {
      return (
        <div className="error-message">
          <div className="error-message-dialog">
            <img onClick={this.props.onClearError} className="close" src={assetsHelper.getAsset('close2.png')} alt="close"/>
            <div className="content">
              {this.props.error}
            </div>
            <button onClick={this.props.onClearError}>{i18nHelper.get('BUTTON_SURE')}</button>
          </div>
        </div>
      );
    }
    return <div className="error-message error-message-nothing"></div>;
  }
});

module.exports = ErrorMessage;


// WEBPACK FOOTER //
// ./src/views/ErrorMessage.jsx